<script>
  import Container from '@/library/container/full-centre.svelte';
  import LgTextBlock from '@/library/content/lg-text-block.svelte';
  import Grid from '@/library/grid/basic-235.svelte';
  import Logo from '@/library/logo/mark.svelte';


  export let clients;

  // let layout = clients.layout;
  // let pretext = clients.content.pretext;
  let context = clients.content.context;
  // let subtext = clients.content.subtext;
  // let meta = clients.meta;
</script>

<style></style>

<section id="about-us" class="py-4xl bg-gray-100">
  <Container>
    <div class="fc ic jc tc">
      <LgTextBlock data={context}></LgTextBlock>
      <div class="">
        <div class="fc h-full">
          <Grid>
            {#each context.items as item}
              <Logo logo={item}></Logo>
            {/each}
          </Grid>
        </div>
      </div>
    </div>
  </Container>
</section>